import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();
const apiUrl = process.env.REACT_APP_API_URL;

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('jwtToken') || null);
    const navigate = useNavigate();

    const login = (token) => {
        const decodedToken = jwtDecode(token);
        console.log('Decoded Token:', decodedToken);  // Debugging token
        const user = {
            id: decodedToken.id,
            username: decodedToken.username,
            roles: decodedToken.roles,
        };
        setUser(user);
        setToken(token);
        localStorage.setItem('jwtToken', token);

        axios.get(`https://api.poketask.fr/api/me`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            console.log('User Data:', response.data);  // Debugging API response
            if (!response.data.hasSelectedStarter) {
                navigate('/starter_selection');
            } else if (decodedToken.roles && decodedToken.roles.includes('ROLE_ADMIN')) {
                navigate('/accueiladmin');
            } else {
                navigate('/dashboard');
            }
        })
        .catch((error) => {
            console.error('Error fetching user data:', error);
            logout();
        });
    };

    const logout = () => {
        localStorage.removeItem('jwtToken');
        setUser(null);
        setToken(null);
        navigate('/title');
    };

    useEffect(() => {
        if (token) {
            const decoded = jwtDecode(token);
            console.log('Decoded Token on Load:', decoded);  // Debugging token on load
            if (decoded.exp * 1000 < Date.now()) {
                logout();
            } else {
                axios.get(`https://api.poketask.fr/api/me`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then((response) => {
                    console.log('User Data on Load:', response.data);  // Debugging API response on load
                    setUser(response.data);
                })
                .catch(() => {
                    logout();
                });
            }
        }
    }, [token]);

    return (
        <AuthContext.Provider value={{ user, token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
